import { render, staticRenderFns } from "./testShows.vue?vue&type=template&id=247c6a92&scoped=true"
import script from "./testShows.vue?vue&type=script&lang=js"
export * from "./testShows.vue?vue&type=script&lang=js"
import style0 from "./testShows.vue?vue&type=style&index=0&id=247c6a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c6a92",
  null
  
)

export default component.exports